// @ts-nocheck
import { CartContext } from "@insite/client-framework/Components/CartContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import useQueryString from "@store/Framework/Common/Hooks/useQueryString";
import { useContext } from "react";
import { useSelector } from "react-redux";

const useCart = (options?: Toolkit.GoogleAnalytics.Options, allowCartState?: boolean) => {
    const cartContext = useContext(CartContext);
    const { cartId } = useQueryString();

    return useSelector((state: ApplicationState) => {
        if (options?.cart) {
            return options.cart;
        }

        if (cartContext) {
            return cartContext;
        }

        if (cartId) {
            return getCartState(state, cartId).value;
        }

        return allowCartState ? getCurrentCartState(state).value : undefined;
    });
};

export default useCart;
